import axiosConfig from './config';

export const getDynamicPopups = async () => await axiosConfig.get('popup');
export const getPopupPageContent = async (mainPopId) => await axiosConfig.get(`popup/page-content/${mainPopId}`);
export const getSourcePageHelp = async (sourcePage) => await axiosConfig.post('popup/source-page-help', { sourcePage });
export const acknowledgePopup = async (mainPopId) => await axiosConfig.post('popup', { mainPopId });
